import { login, auditlogout } from "../../helpers/fetching";

export default {
  state: {
    loggedInUserSilver:
      localStorage.getItem("userInfo") != null
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
    loading: false,
    error: null,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setUser(state, data) {
      state.loggedInUserSilver = data;
      state.loading = false;
      state.error = null;
    },
  },
  actions: {
    loginAction({ commit }, { email, password, captchaToken }) {
      commit("clearError");
      commit("setLoading", true);
      return login({ email, password, captchaToken })
        .then((response) => {
          commit("setUser", { uid: response });
          localStorage.setItem("userInfo", JSON.stringify(response));
          return {
            response: true,
            message: "",
          };
        })
        .catch((response) => {
          console.error("Login error", response);
          commit("setError", response);
          localStorage.removeItem("userInfo");
          return {
            response: false,
            message: response,
          };
        });
    },
    /* eslint-disable */
    signOut({ commit }) {
      return new Promise(resolve => {
        auditlogout()
        .then(response => {
          console.log(response)
          commit("clearError");
          localStorage.removeItem("userInfo");
          commit("setUser", null);
          // this.$router.push({ path: "/sessions/login" });
          resolve()
        })
        .catch(error => {
          console.error(error);
          localStorage.removeItem("userInfo");
          commit("setUser", null);
          resolve()
        })
      })
    },
    /* eslint-enable */
  },
};
